import React, { useState, useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AppContext } from '../window';
import { useTranslation } from '../i18n';
import { Link } from 'react-router';
import ReactLazy = React.lazy;
const TermsConditionsModal = ReactLazy(() => import('../about/TermsConditionsModal'));
const PrivacyPolicyModal = ReactLazy(() => import('../about/PrivacyPolicyModal'));
const ContactModal = ReactLazy(() => import('../about/ContactModal'));
const ImpressumModal = ReactLazy(() => import('../about/ImpressumModal'));
const PricesModal = ReactLazy(() => import('../about/PricesModal'));

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { texts, location } = useContext(AppContext);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showImpressumModal, setShowImpressumModal] = useState(false);
  const [showPricesModal, setShowPricesModal] = useState(false);

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPrivacyModal(true);
  };

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowContactModal(true);
  };

  const handleImpressumClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowImpressumModal(true);
  };

  const handlePricesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowPricesModal(true);
  };

  const showImpressum = location?.country?.iso?.toLowerCase() === 'de';

  return (
    <>
      <footer className="app-footer">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} className="text-center">
              <div className="footer-links">
                <Link to="/about" className="footer-link">
                  {t('general.about_faq')}
                </Link>
                <span className="footer-separator">•</span>
                <a href="#" onClick={handlePricesClick} className="footer-link">
                  {t('about.prices')}
                </a>
                <span className="footer-separator">•</span>
                <a href="#" onClick={handleTermsClick} className="footer-link">
                  {t('about.terms_conditions')}
                </a>
                <span className="footer-separator">•</span>
                <a href="#" onClick={handlePrivacyClick} className="footer-link">
                  {t('about.privacy_policy')}
                </a>
                {showImpressum && (
                  <>
                    <span className="footer-separator">•</span>
                    <a href="#" onClick={handleImpressumClick} className="footer-link">
                      {t('about.impressum')}
                    </a>
                  </>
                )}
                <span className="footer-separator">•</span>
                <a href="#" onClick={handleContactClick} className="footer-link">
                  {t('about.contact')}
                </a>
              </div>
              <div className="footer-copyright">
                <small>
                  {t('general.footer_copyright', { year: "2025 - " +new Date().getFullYear() })}
                  <span className="footer-separator"> • </span>
                  {t('general.footer_disclaimer')}
                </small>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

  <React.Suspense fallback={null}>
  <TermsConditionsModal 
        show={showTermsModal} 
        onHide={() => setShowTermsModal(false)} 
      />

  <PrivacyPolicyModal 
        show={showPrivacyModal} 
        onHide={() => setShowPrivacyModal(false)} 
      />

  <ContactModal
        show={showContactModal}
        onHide={() => setShowContactModal(false)}
      />

      {showImpressum && (
  <ImpressumModal
          show={showImpressumModal}
          onHide={() => setShowImpressumModal(false)}
        />
      )}

  <PricesModal
        show={showPricesModal}
        onHide={() => setShowPricesModal(false)}
      />
  </React.Suspense>
    </>
  );
};

export default Footer;